<app-data-table [columns]="columns" [data]="employeeTable()" [filters]="filters" [totalRecords]="totalRecords()"
  [cardTemplate]="card" (pageChange)="onPage($event)" (add)="onAdd()" (edit)="onEdit($event)"
  (removeSelected)="onRemoveSelected($event)" (search)="onSearch($event)" />

<ng-template #card let-employee>
  <div class="surface-card shadow-2 p-3 border-round h-full flex flex-column">
    <div class="flex align-items-center justify-content-between mb-3">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center bg-orange-100 text-orange-500 border-circle w-3rem h-3rem font-bold text-xl mr-2">
          {{ employee.username.charAt(0).toUpperCase() }}
        </div>
        <div>
          <div class="font-bold text-900">{{ employee.username }}</div>
          <div class="text-500 text-sm">
            {{ employee.categories && employee.categories.length > 0 ? employee.categories.join(', ') : 'Sin categorías'
            }}
          </div>
        </div>
      </div>
      <p-button icon="pi pi-ellipsis-v" [text]="true" [rounded]="true" severity="secondary"
        (onClick)="onEdit(employee)"></p-button>
    </div>

    <div class="flex flex-column gap-2 mt-auto">
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-envelope text-500"></i>
        <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ employee.email }}</span>
      </div>
    </div>

    <div class="flex gap-2 mt-3 pt-3 border-top-1 surface-border">
      <a pButton class="flex-1 p-button-outlined p-button-sm justify-content-center no-underline"
        href="mailto:{{employee.email}}">
        <i class="pi pi-envelope mr-2"></i> Email
      </a>
    </div>
  </div>
</ng-template>

<app-add-employee [(visible)]="dialogVisible" (save)="onSave($event)" />